import type { VirtualAgentSummary } from 'shared/src'

export const useAgentStatusMeta = () => {
  const getStatusMeta = (status: string) => {
    switch (status) {
      case 'stable':
        return { color: 'success', icon: 'positive-check' }
      case 'on_hold':
        return { color: 'onhold', icon: 'hours' }
      case 'error':
        return { color: 'error', icon: 'error' }
      case 'warning':
        return { color: 'warning', icon: 'warning' }
      case 'assigned':
        return { color: 'assigned', icon: 'user' }
      case 'handled':
        return { color: 'handled', icon: 'phone' }
      case 'routing':
        return { color: 'routing', icon: 'routing' }
      case 'statuserror':
        return { color: 'statuserror', icon: 'alert_triangle' }
      case 'junk':
        return { color: 'junk', icon: 'trash' }
      default:
        return { color: 'neutral', icon: 'information' }
    }
  }

  const getBadgeColor = (agent: VirtualAgentSummary): string => {
    if (!agent.agentStatus) return 'neutral'

    if (agent.problematicCallsCount && agent.problematicCallsCount > 0) {
      return 'warning'
    }

    return getStatusMeta(agent.agentStatus).color || 'neutral'
  }

  const getBadgeIcon = (agent: VirtualAgentSummary): string => {
    if (!agent.agentStatus) return 'information'

    if (agent.problematicCallsCount && agent.problematicCallsCount > 0) {
      return 'warning'
    }

    return getStatusMeta(agent.agentStatus).icon || 'information'
  }

  return {
    getStatusMeta,
    getBadgeColor,
    getBadgeIcon,
  }
}
